'use strict';

module.exports = {
  template: require('./auth-login.html'),
  controller: require('./auth-login.controller'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/auth-login/index.js
 ** module id = 171
 ** module chunks = 0
 **/